// import { BusinessObjectAssembler } from './BusinessObjectAssemblerFactory';
import { ValidBusinessObject } from '@iotv/iotv-v3-types'
import { createBusinessObjectAssembler } from './BusinessObjectAssemblerFactory'
import * as ModelClasses from './model'
import { ModelCommon } from './model/ModelCommon'
import { DEBUG_OVERRIDE, NOT_LAMBDA } from './util/lambda/debug'

const debug = DEBUG_OVERRIDE || (NOT_LAMBDA && false)

const nothing: ValidBusinessObject = {} as ValidBusinessObject
debug && console.log(`Unussed variable ${nothing} To make tsc emit .d.ts files with @iotv/iotv-v3-types references instead of ../iotvv3-types`)

const filtered = Object.entries(ModelClasses).filter(([k, c]) => {
  const descriptor = Object.getOwnPropertyDescriptor(ModelClasses, k)
  return descriptor?.get ? descriptor.get()?.prototype instanceof ModelCommon : false
})

const filteredModel = Object.fromEntries(filtered)

const BusinessObjectAssemblerL = createBusinessObjectAssembler(ModelClasses)

export { BusinessObjectAssemblerL as BusinessObjectAssembler }
